<template>
  <div>
    <el-form
      ref="KeyFrom"
      :model="keyMod"
      label-position="top"
      label-width="130px"
      size="mini"
      :rules="rules"
    >
      <el-form-item label="词汇" prop="keyWord">
        <el-input v-model="keyMod.keyWord"></el-input>
      </el-form-item>
      <el-form-item label="微信指数采集词汇(只用于采集端)" prop="wciKeyWord">
        <el-input v-model="keyMod.wciKeyWord"></el-input>
      </el-form-item>
      <el-form-item label="抖音指数采集词汇(只用于采集端)" prop="tkKeyWord">
        <el-input v-model="keyMod.tkKeyWord"></el-input>
      </el-form-item>
      <el-form-item label="状态" prop="state">
        <a-switch
          v-model:checked="keyMod.state"
          checked-children="启用"
          un-checked-children="禁用"
        />
      </el-form-item>

      <el-form-item label="">
        <el-button type="primary" @click="EditComHandle('KeyFrom')"
          >确定</el-button
        >
        <el-button @click="CancleEdit">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { showBizeEdit } from "@/api/showbiz";
export default {
  props: {
    keyMod: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      rules: {
        keyWord: [
          { required: true, message: "请输入词汇", trigger: "change" },
          { required: true, message: "请输入词汇", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    EditComHandle(fromName) {
      this.$refs[fromName].validate((valid) => {
        showBizeEdit(
          this.keyMod.id,
          this.keyMod.keyWord,
          this.keyMod.wciKeyWord,
          this.keyMod.tkKeyWord,
          this.keyMod.state
        ).then((res) => {
          if (res.code == 0) {
            this.$message.success(res.msg);
            this.$emit("EditComHandle");
          } else {
            this.$message.error(res.msg);
          }
        });
      });
    },
    CancleEdit() {
      this.$emit("EditComHandle");
    },
  },
};
</script>

<style lang="scss" scoped>
</style>